import React from 'react';
import { Route } from 'react-router-dom';

const PermissionRoute = (props) => {
  const { permissionGranted, ...rest } = props;

  if (permissionGranted) {
    return (
      <Route {...rest} />
    );
  }

  return null;
};

export default PermissionRoute;



// WEBPACK FOOTER //
// ./src/components/permission/permissionRoute.js